export const characters = /^[A-Za-z\-_]+$/;
export const checkWhiteSpace = "^[_A-z0-9]{1,}$";
export const datePattern = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z?)/;
export const email = /^[A-Za-z0-9]+(?:[.-][A-Za-z0-9]+)*@[A-Za-z0-9]+(?:[.-][A-Za-z0-9]+)*\.[A-Za-z]{2,3}$/;
export const formatter = /[^a-zA-Z0-9-]+/g;
export const number = /\d/;
export const onlyAlphabets = /[a-z]/i;
